import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import "./GerenciarUsuarios.css";

const GerenciarUsuarios = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [filters, setFilters] = useState({ nome: "", email: "", status: "" });
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [syncing, setSyncing] = useState(false);
  const [syncDots, setSyncDots] = useState(".");
  const navigate = useNavigate();
  


  useEffect(() => {
    fetchUsuarios();
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

useEffect(() => {
  if (!syncing) {
    setSyncDots(".");
    return;
  }

  const interval = setInterval(() => {
    setSyncDots((prev) => {
      if (prev === ".") return "..";
      if (prev === "..") return "...";
      return ".";
    });
  }, 400);

  return () => clearInterval(interval);
}, [syncing]);


  const fetchUsuarios = async () => {
    try {
      const params = new URLSearchParams(filters).toString();
      const response = await fetch(
        `https://welaunchyou.com.br/crm-wly/gerenciar_usuarios.php?${params}`,
        { credentials: "include" }
      );

      const data = await response.json();
      if (data.usuarios) {
        setUsuarios(data.usuarios);
      } else {
        setUsuarios([]);
        setError("Nenhum usuário encontrado.");
      }
    } catch (error) {
      setError("Erro ao buscar usuários.");
    }
  };

  const handleEdit = (id) => {
    navigate(`/editar-usuario/${id}`);
};


  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    fetchUsuarios();
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Tem certeza que deseja excluir este usuário?")) return;

    try {
      const response = await fetch(
        `https://welaunchyou.com.br/crm-wly/gerenciar_usuarios.php?delete_id=${id}`,
        { method: "GET", credentials: "include" }
      );

      if (response.ok) {
        setMessage("Usuário excluído com sucesso!");
        fetchUsuarios(); // Atualiza a lista após exclusão
      } else {
        setError("Erro ao excluir usuário.");
      }
    } catch (error) {
      setError("Erro ao conectar ao servidor.");
    }
  };

const handleSyncAsaas = async () => {
  if (syncing) return;

  try {
    setSyncing(true);
    setMessage("");
    setError("");

    const response = await fetch(
      "https://welaunchyou.com.br/crm-wly/api/integracoes/sync_asaas.php",
      { method: "GET", credentials: "include" }
    );

    const data = await response.json();

    if (data.success) {
      setMessage("Clientes sincronizados com sucesso!");
      fetchUsuarios();
    } else {
      setError(data.message || "Erro ao sincronizar clientes.");
    }
  } catch (error) {
    setError("Erro ao conectar ao servidor.");
  } finally {
    setSyncing(false);
  }
};


  return (
    <div className="c2-usuarios">
      <h1>Gerenciamento de Usuários</h1>

      {message && <p className="success-message">{message}</p>}
      {error && <p className="error-message">{error}</p>}

      <form className="filter-form" onSubmit={handleFilterSubmit}>
        <div className="form-group">
          <label>Nome:</label>
          <input
            type="text"
            name="nome"
            value={filters.nome}
            onChange={handleFilterChange}
          />
        </div>
        <div className="form-group">
          <label>E-mail:</label>
          <input
            type="text"
            name="email"
            value={filters.email}
            onChange={handleFilterChange}
          />
        </div>
        <div className="form-group">
  <label>Status:</label>
  <select name="status" value={filters.status} onChange={handleFilterChange}>
    <option value="">Todos</option>
    <option value="ativo">Ativo</option>
    <option value="inativo">Inativo</option>
  </select>
</div>

        <button className="botao-filtro" type="submit">Filtrar</button>
      </form>

      <Link to="/adicionar-usuario" className="button">Adicionar Novo Usuário</Link>

        <button
          className="button sync-button"
          onClick={handleSyncAsaas}
          disabled={syncing}
        >
          {syncing ? `Sincronizando${syncDots}` : "Sincronizar Clientes"}
        </button>


      <table className="usuarios-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Nome</th>
            <th>E-mail</th>
            <th>Tipo</th>
            <th>Ações</th>
            <th>Status</th>

          </tr>
        </thead>
        <tbody>
          {usuarios.length > 0 ? (
            usuarios.map((usuario) => (
              <tr key={usuario.id}>
                <td>{usuario.id}</td>
                <td>{usuario.nome}</td>
                <td>{usuario.email}</td>
                <td>{usuario.tipo_usuario}</td>
                <td>{usuario.status}</td>
                <td>
    <div className="action-buttons">
        <button className="button-editar" onClick={() => handleEdit(usuario.id)}>Editar</button>
        <button className="button delete-button" onClick={() => handleDelete(usuario.id)}>Excluir</button>
    </div>
</td>

              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6">Nenhum usuário encontrado.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default GerenciarUsuarios;
